import { Store } from 'redux'
import configureStore from './configureStore'

export const store: Store = configureStore({})

export const useDispatch = () => store.dispatch

export const useSelector = (selector: any) => selector(store.getState())
